import { render, staticRenderFns } from "./DeclarationDetails.vue?vue&type=template&id=42a953e2&"
import script from "./DeclarationDetails.vue?vue&type=script&lang=js&"
export * from "./DeclarationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports